module.exports = {
  selectLanguage: 'Избери език',
};
